export const FETCH_ALL_COURSES_REQUESTED = "FETCH_ALL_COURSES_REQUESTED"
export const FETCH_ALL_COURSES_SUCCESSFUL = "FETCH_ALL_COURSES_SUCCESSFUL"
export const FETCH_ALL_COURSES_FAILED = "FETCH_ALL_COURSES_FAILED"
export const FETCH_SUBCATEGORY_REQUESTED = "FETCH_SUBCATEGORY_REQUESTED"
export const FETCH_SUBCATEGORY_SUCCESSFUL = "FETCH_SUBCATEGORY_SUCCESSFUL"
export const FETCH_SUBCATEGORY_FAILED = "FETCH_SUBCATEGORY_FAILED"
export const FETCH_COURSE_BY_ID_REQUESTED = "FETCH_COURSE_BY_ID_REQUESTED"
export const FETCH_COURSE_BY_ID_SUCCESSFUL = "FETCH_COURSE_BY_ID_SUCCESSFUL"
export const FETCH_COURSE_BY_ID_FAILED = "FETCH_COURSE_BY_ID_FAILED"
export const FETCH_SIMILAR_COURSES_REQUESTED = "FETCH_SIMILAR_COURSES_REQUESTED"
export const FETCH_SIMILAR_COURSES_SUCCESSFUL =
  "FETCH_SIMILAR_COURSES_SUCCESSFUL"
export const FETCH_SIMILAR_COURSES_FAILED = "FETCH_SIMILAR_COURSES_FAILED"

export const UPLOAD_SNAPSHOT_REQUESTED = "UPLOAD_SNAPSHOT_REQUESTED"
export const UPLOAD_SNAPSHOT_SUCCESSFUL = "UPLOAD_SNAPSHOT_SUCCESSFUL"
export const UPLOAD_SNAPSHOT_FAILED = "UPLOAD_SNAPSHOT_FAILED"

export const FETCH_CATEGORIES_REQUESTED = "FETCH_CATEGORIES_REQUESTED"
export const FETCH_CATEGORIES_SUCCESSFUL = "FETCH_CATEGORIES_SUCCESSFUL"
export const FETCH_CATEGORIES_FAILED = "FETCH_CATEGORIES_FAILED"

export const FETCH_SCHOOL_BUNDLES_REQUESTED = "FETCH_SCHOOL_BUNDLES_REQUESTED"
export const FETCH_SCHOOL_BUNDLES_SUCCESSFUL = "FETCH_SCHOOL_BUNDLES_SUCCESSFUL"
export const FETCH_SCHOOL_BUNDLES_FAILED = "FETCH_SCHOOL_BUNDLES_FAILED"

export const FETCH_BUNDLE_BY_ID_REQUESTED = "FETCH_BUNDLE_BY_ID_REQUESTED"
export const FETCH_BUNDLE_BY_ID_SUCCESSFUL = "FETCH_BUNDLE_BY_ID_SUCCESSFUL"
export const FETCH_BUNDLE_BY_ID_FAILED = "FETCH_BUNDLE_BY_ID_FAILED"

export const FETCH_COURSE_VOUCHER_REQUESTED = "FETCH_COURSE_VOUCHER_REQUESTED"
export const FETCH_COURSE_VOUCHER_SUCCESSFUL = "FETCH_COURSE_VOUCHER_SUCCESSFUL"
export const FETCH_COURSE_VOUCHER_FAILED = "FETCH_COURSE_VOUCHER_FAILED"

export const FETCH_BUNDLE_VOUCHER_REQUESTED = "FETCH_BUNDLE_VOUCHER_REQUESTED"
export const FETCH_BUNDLE_VOUCHER_SUCCESSFUL = "FETCH_BUNDLE_VOUCHER_SUCCESSFUL"
export const FETCH_BUNDLE_VOUCHER_FAILED = "FETCH_BUNDLE_VOUCHER_FAILED"

export const REMOVE_VOUCHER = "REMOVE_VOUCHER"

export const SET_SNAPSHOT_ERROR = "SET_SNAPSHOT_ERROR"
export const SET_VERIFICATION_ERROR = "SET_VERIFICATION_ERROR"

export const SHOW_CLASS_KYC_MODAL = "SHOW_CLASS_KYC_MODAL"
export const HIDE_CLASS_KYC_MODAL = "HIDE_CLASS_KYC_MODAL"

export const VERIFY_USER_SELFIE_REQUESTED = "VERIFY_USER_SELFIE_REQUESTED"
export const VERIFY_USER_SELFIE_SUCCESSFUL = "VERIFY_USER_SELFIE_SUCCESSFUL"
export const VERIFY_USER_SELFIE_FAILED = "VERIFY_USER_SELFIE_FAILED"

export const APPLY_COURSE_APT_COINS_REQUESTED =
  "APPLY_COURSE_APT_COINS_REQUESTED"
export const APPLY_COURSE_APT_COINS_SUCCESSFUL =
  "APPLY_COURSE_APT_COINS_SUCCESSFUL"
export const APPLY_COURSE_APT_COINS_FAILED = "APPLY_COURSE_APT_COINS_FAILED"

export const APPLY_BUNDLE_APT_COINS_REQUESTED =
  "APPLY_BUNDLE_APT_COINS_REQUESTED"
export const APPLY_BUNDLE_APT_COINS_SUCCESSFUL =
  "APPLY_BUNDLE_APT_COINS_SUCCESSFUL"
export const APPLY_BUNDLE_APT_COINS_FAILED = "APPLY_BUNDLE_APT_COINS_FAILED"

export const GET_PAYMENT_CHANNELS_REQUESTED = "GET_PAYMENT_CHANNELS_REQUESTED"
export const GET_PAYMENT_CHANNELS_SUCCESSFUL = "GET_PAYMENT_CHANNELS_SUCCESSFUL"
export const GET_PAYMENT_CHANNELS_FAILED = "GET_PAYMENT_CHANNELS_FAILED"

export const GET_PAYMENT_FEES_REQUESTED = "GET_PAYMENT_FEES_REQUESTED"
export const GET_PAYMENT_FEES_SUCCESSFUL = "GET_PAYMENT_FEES_SUCCESSFUL"
export const GET_PAYMENT_FEES_FAILED = "GET_PAYMENT_FEES_FAILED"

export const POST_PAYMENT_REQUESTED = "GET_PAYMENT_REQUESTED"
export const POST_PAYMENT_SUCCESSFUL = "POST_PAYMENT_SUCCESSFUL"
export const POST_PAYMENT_FAILED = "POST_PAYMENT_FAILED"

export const GET_TRANSACTION_REQUESTED = "GET_TRANSACTION_REQUESTED"
export const GET_TRANSACTION_SUCCESSFUL = "GET_TRANSACTION_SUCCESSFUL"
export const GET_TRANSACTION_FAILED = "GET_TRANSACTION_FAILED"

export const REMOVE_COINS = "REMOVE_COINS"

export const SET_DARK_MODE = "SET_DARK_MODE"

export const FETCH_TRANSACTION_DETAILS_REQUESTED =
  "FETCH_TRANSACTION_DETAILS_REQUESTED"
export const FETCH_TRANSACTION_DETAILS_SUCCESSFUL =
  "FETCH_TRANSACTION_DETAILS_SUCCESSFUL"
export const FETCH_TRANSACTION_DETAILS_FAILED =
  "FETCH_TRANSACTION_DETAILS_FAILED"
